const INFO_KEY = 'userinfo'
const HISTORY_KEY = 'hm_history_list'

export const getInfo = () => {
  const result = localStorage.getItem(INFO_KEY)
  return result ? JSON.parse(result) : { token: '', userId: '', identify: '' }
}

export const setInfo = (info) => {
  localStorage.setItem(INFO_KEY, JSON.stringify(info))
  if (info.children && info.children.length > 0) {
    let student = info.children[0]
    localStorage.setItem('childrenInfo', JSON.stringify(student))
  }
}

export const removeInfo = () => {
  localStorage.removeItem(INFO_KEY)
  localStorage.removeItem('childrenInfo')
  localStorage.removeItem('currentClass')
}

export const setHistoryList = (arr) => {
  localStorage.setItem(HISTORY_KEY, JSON.stringify(arr))
}

export const getHistoryList = () => {
  const result = localStorage.getItem(HISTORY_KEY)
  return result ? JSON.parse(result) : []
}
